/**
 * Defines the structure of the user profile information.
 */
interface Profile {
  email: string;
  name?: string;
  picture?: string;
}

/**
 * Defines the context type for user-related operations.
 */
export interface UserInfo extends Profile {
  organisation: {
    id: number;
    name: string;
    description: string;
  };
  fulcrum_api_key?: string;
  has_fulcrum_api_key?: boolean;
  fulcrum_region?: "AU" | "US" | "EU";
  is_staff?: boolean;
  is_superuser?: boolean;
}

export class UserProfileError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "UserProfileError";
  }
}

export class AuthenticationError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "AuthenticationError";
  }
}
